export default "__VITE_ASSET__D6b$LRG1__"